<template>
    <BTable
        :items="rowsLocal"
        :fields="fields"
        striped
        responsive
        class="history_table cursor-pointer"
        @row-clicked="onRowClicked"
        :tbody-tr-attr="rowAttrs"
    >
        <template #cell(quantity_fmt)="{ item }">
            {{ preferFmt(item.quantity_fmt, item.quantity) }}
        </template>
        
        <template #cell(max_price_fmt)="{ item }">
            {{ preferFmt(item.max_price_fmt, item.max_price) }}
        </template>
        
        <template #cell(latest_price_fmt)="{ item }">
      <span v-if="item.latest_price !== null && item.latest_price !== undefined">
        {{ preferFmt(item.latest_price_fmt, item.latest_price) }}
      </span>
            <span v-else>Пропозицій немає</span>
        </template>
        
        <template #row-details="{ item }">
            <div class="details-wrap">
                <table class="w-100 subtable">
                    <thead>
                    <tr class="subhead">
                        <th class="w-32"></th>
                        <th>Дата ставки</th>
                        <th>Учасник</th>
                        <th class="text-end">Ставка</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="!item.history || !item.history.length">
                        <td colspan="4" class="py-2 text-center">Історія відсутня</td>
                    </tr>
                    <tr v-for="h in item.history" :key="h.id">
                        <td class="w-32"></td>
                        <td>{{ h.added_fmt ?? h.added }}</td>
                        <td>{{ h.user_company ?? ('user#' + (h.user_id ?? '')) }}</td>
                        <td class="text-end">{{ h.cur_price_fmt ?? (h.cur_price ?? '') }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </BTable>
    
    <div id="positions_control container-fluid" >
        <div class="row">
            <div class="col-2">
                Стартова сума:
            </div>
            <div class="summ_opt col-3">{{sumStart}}</div>
        </div>
        <div class="row">
            <div class="col-2">
                Поточна сума:
            </div>
            <div class="summ_current col-10" >{{sumCurrent}}</div>
        </div>
        
        <div class="row" v-if="can_edit">
            <div class="col-6">
                <div
                    class="btn btn-danger btn_auto_render waves-effect waves-themed"
                    v-on:click="changePositions"
                >
                    Змінити заявки першого туру
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BTable } from 'bootstrap-vue-next'

export default {
    name: 'reduction_positions',
    components: { BTable },
    props: {
        can_edit : {
            type : Boolean,
            default : true,
        },
        
        protocol: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            rowsLocal: [],
            fields: [
                { key: 'recid',            label: 'id', thStyle: { width: '35px' } },
                { key: 'title',            label: 'Лот' },
                { key: 'catalog_number',   label: 'Кат. номер' },
                { key: 'unit',             label: 'Од.' },
                { key: 'quantity_fmt',     label: 'Кількість' },
                { key: 'max_price_fmt',    label: 'Стартова ціна' },
                { key: 'latest_price_fmt', label: 'Ціна торгів' },
            ],
        }
    },

    watch: {
        buildItems: {
            immediate: true,
            handler(arr) {
                this.rowsLocal = (arr || []).map(r => ({ ...r, _showDetails: false }))
            },
        },
    },
    
    methods: {
        changePositions() {
            EventBus.$emit('show_position_change');
        },
        onRowClicked(item) {
            item._showDetails = !item._showDetails
        },
        
        preferFmt(fmt, raw) {
            return fmt ?? (raw ?? '')
        },
        
        rowAttrs(item, type) {
            if (type === 'row') {
                return { style: 'cursor:pointer', role: 'button', tabindex: '0' }
            }
            return {}
        },
    },
    
    computed: {
        buildItems() {
            const bi = this.protocol?.reduction?.build_items
            return Array.isArray(bi) ? bi : []
        },
        
        tender () {
            return this.protocol.tender;
        },
        
        reduction_field() {
            return this.tender?.reduction_param;
        },
        
        reduction_sum_params() {
            return this.reduction_field?.parsm
        },
        
        sumStart() {
            return this?.reduction_sum_params?.summStartTxt || 0;
        },
        
        sumCurrent() {
            return this?.reduction_sum_params?.summCurrentTxt || 0;
        },
        
    },
}
</script>



<style scoped>
.history_table :deep(thead th) { font-weight: 600; }
.details-wrap { background: #f8f9fa; padding: 6px 8px; border-radius: 4px; }
.subtable { border-collapse: collapse; }
.subtable th, .subtable td { padding: 8px; }
.subhead { background: #e9ecef; }
.w-32 { width: 32px; }
.text-end { text-align: end; }
</style>
